import {useEffect, useRef} from 'react';
import useTypedSelector from '../../common/hook/useTypedSelector';
import {useFetchInfo} from '../../common/util/fetch';
import {sendPageView} from '../../common/util/tracking';
import {ActionType} from '../state/action';
import {IViewTypeV4} from '../type';

export default function useSearchPageViewV4({
  viewType,
  keyword,
}: {
  viewType: IViewTypeV4;
  keyword: string;
}) {
  const totalCount = useTypedSelector(state => state.search.result.totalCount);
  const {isFetched} = useFetchInfo(ActionType.FetchResult);
  const keywordRef = useRef(keyword);
  useEffect(() => {
    keywordRef.current = keyword;
  }, [keyword]);

  useEffect(() => {
    const keyword = keywordRef.current;

    if (viewType === 'resultView' && isFetched) {
      sendSearchPageView({
        page: 'search_result',
        actionName: 'result',
        customProps: {
          search_keyword: keyword,
          search_type:
            keyword.indexOf('#') === 0 ? 'genre_search' : 'total_search',
          search_result_count: totalCount,
        },
      });
    } else if (viewType === 'searchView') {
      sendSearchPageView({
        page: 'search_home',
        actionName: 'home',
      });
    }
  }, [isFetched, totalCount, viewType]);
}

function sendSearchPageView({
  page,
  actionName,
  customProps,
}: {
  page: string;
  actionName: string;
  customProps?: {[key: string]: any};
}) {
  sendPageView({
    section: 'search',
    page,
    actionName,
    customProps,
    isSendExtra: true,
  });
}
